module.exports = __webpack_public_path__ + "assets/img/title2.124762f3.png";